import Vue from 'vue'
import VueRouter from 'vue-router'
import Tablero from '../views/Tablero.vue'
import Productos from '../views/Productos.vue'
import Personas from '../views/Personas.vue'
import DefinicionesDeImpuestos from '../views/DefinicionesDeImpuestos.vue'
import FacturasDeCompra from '../views/FacturasDeCompra.vue'
import FacturasDeVenta from '../views/FacturasDeVenta.vue'
import Usuarios from '../views/Usuarios.vue'
import PuntosDeVentaInicio from '../views/PuntosDeVenta/PuntosDeVentaInicio.vue'
import PuntosDeVentaListado from '../views/PuntosDeVenta/PuntosDeVentaListado.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Tablero',
    component: Tablero
	},
	{
    path: '/productos',
    name: 'Productos',
    component: Productos
  },
	{
    path: '/personas',
    name: 'Personas',
    component: Personas
  },
	{
    path: '/definiciones-de-impuestos',
    name: 'DefinicionesDeImpuestos',
    component: DefinicionesDeImpuestos
  },
	{
    path: '/facturas-de-compra',
    name: 'FacturasDeCompra',
    component: FacturasDeCompra
  },
	{
    path: '/facturas-de-venta',
    name: 'FacturasDeVenta',
    component: FacturasDeVenta
  },
  {
    path: '/puntos-de-venta',
    name: 'PuntosDeVenta',
    component: PuntosDeVentaInicio,
    children: [
      {
        path: '',
        component: PuntosDeVentaListado,
      }
    ]
  },
	{
    path: '/usuarios',
    name: 'Usuarios',
    component: Usuarios
  },
]

const router = new VueRouter({
  routes
})

export default router
